module.exports = __webpack_public_path__ + "assets/img/11_742.c47c2aaf.jpg";